<e-list
  [header]="headerText"
  class="fill-height overflow-hidden"
  search
  [(searchText)]="searchText"
  >
  <ng-container slot="header">
    <div style="width: 100%">
      <div class="btn-group app-pages-toggle" style="width: 100%">
        <button
          eBtn
          straightCorners
          class="app-pages-toggle-btn"
          [color]="filterMode === 'appMatch' ? 'elegant' : 'highlight'"
          (click)="filterMode = 'appMatch'"
          >
          App match
        </button>
        <button
          eBtn
          straightCorners
          class="app-pages-toggle-btn"
          [color]="filterMode === 'all' ? 'elegant' : 'highlight'"
          (click)="filterMode = 'all'"
          >
          Alle
        </button>
        <button
          eBtn
          straightCorners
          class="app-pages-toggle-btn"
          [color]="filterMode === 'notInUse' ? 'elegant' : 'highlight'"
          (click)="filterMode = 'notInUse'"
          >
          Niet in gebruik
        </button>
      </div>
    </div>
  </ng-container>

  <div cdkDropList [cdkDropListConnectedTo]="connectedDropLists">
    @for (page of filteredEgiPages; track page) {
      <e-list-item>
        <span
          cdkDrag
          [cdkDragData]="page"
          cdkDragPreviewClass="page-drag-preview"
          class="ag-drag-handle mb-2"
          >
          <navigation-item-type-tag [type]="pageType"></navigation-item-type-tag>
          {{ page.config.name }}
        </span>
        <egi-page-info showTopic hideName [metaData]="page.metaData"></egi-page-info>
        <span slot="append">
          @if (isInUse(page)) {
            <e-badge
              small
              color="success"
              textWhite
              prependIcon="check"
              class="page-usage-badge"
              >
              In gebruik
            </e-badge>
          } @else {
            <e-badge small color="between-highlight-and-separator" class="page-usage-badge">
              Niet in gebruik
            </e-badge>
          }
        </span>
      </e-list-item>
    }
  </div>
</e-list>
